<script setup lang="ts">
import { PageWrapperComponent, type SocialItem } from '@metapic-apps/shared'
import { computed } from 'vue'

import { CostsTab } from '@/components/influencer/CostsTab'
import InfluencerContentLibrary from '@/components/influencer/InfluencerContentLibrary.vue'
import { PerformanceTab } from '@/components/influencer/PerformanceTab'
import { LinksList } from '@/components/LinksList'
import { useAdvertiserPermissions } from '@/lib/hooks/advertiser-permissions.hooks'
import TabsComponent from '@/ui-library/molecules/TabsComponent.vue'

const props = defineProps<{
  influencer: { userId: number; username: string; socialMediaAccounts?: SocialItem[] }
}>()

const { hideEdit } = useAdvertiserPermissions()

const userIds = computed(() => [props.influencer.userId])

const tabs = computed(() => {
  const base = [
    { label: 'Performance', path: 'performance' },
    { label: 'Content', path: 'content' },
    { label: 'Links', path: 'links' },
  ]
  if (!hideEdit.value) {
    base.push({ label: 'Costs', path: 'costs' })
  }
  return base
})
</script>
<template>
  <PageWrapperComponent :pt="16">
    <TabsComponent has-dynamic-urls :tabs="tabs" paddings="16px 0px 24px 0px">
      <template #tab1>
        <PerformanceTab :creator-id="props.influencer.userId" />
      </template>
      <template #tab2>
        <InfluencerContentLibrary :influencer="props.influencer" />
      </template>
      <template #tab3>
        <LinksList :user-ids="userIds" />
      </template>
      <template v-if="!hideEdit" #tab4>
        <CostsTab :creator-id="props.influencer.userId" />
      </template>
    </TabsComponent>
  </PageWrapperComponent>
</template>
<style lang="scss" scoped>
:deep(.card-container) {
  box-shadow: none;
  padding: 0;
}
</style>
